<template>
  <div class="sighDetailContainter">
    <breadcrumb class="breadcrumbPosition">
      <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/personal/sign/home' }">签约管理</el-breadcrumb-item>
        <el-breadcrumb-item>签约详情</el-breadcrumb-item>
      </el-breadcrumb>
    </breadcrumb>
    <header-detail @getDetial="goToFlow" :detail="detail" v-if="detail" class="listPosition"></header-detail>
    <!-- v-if="detail&&detail.attachmentList&&detail.attachmentList.length" -->
    <div class="annexContainer" v-if="detail&&detail.attachmentList&&detail.attachmentList.length">
      <div class="annexDscp">
        <img src="@image/annex/annex_icon.png">
        <span>{{'附件'+detail.attachmentList.length+'个'}}</span>
        <span class="delimit">|</span>
        <span class="allDoload" @click="downAll">打包下载</span>
      </div>
      <annex
        ref="annex"
        :fileList="detail.attachmentList"
        :contractId="$route.query.id"
        :contractName="detail.info.name"
        :showType="'download'"
      ></annex>
    </div>

    <div
      class="tabContainer"
      :class="{'noHaveAnnex':!detail.attachmentList||!detail.attachmentList.length}"
    >
      <el-tabs v-model="activeName" type="card" @tab-click="activeChange">
        <el-tab-pane label="签约流程" name="flow" class="flowContainer">
          <slide
            :detail="detail"
            @rejectSignShow="rejectSignShow"
            @restDetail="activeChange"
            v-if="detail"
          ></slide>
        </el-tab-pane>
        <!-- <el-tab-pane label="履约任务" name="waitSign" v-if="hasPerform">
          <perform-sign class="performContainer" @getDetail="init" ref="performSign"></perform-sign>
        </el-tab-pane> -->
        <!-- <el-tab-pane label="变更历史" name="changeHistory" class="performContainer">
          <change-history-list :data="historyList" :detail="detail" v-if="detail"></change-history-list>
        </el-tab-pane>-->
        <el-tab-pane label="预警提醒" name="waringSign">
          <warning-tip-list :data="waringList"></warning-tip-list>
          <PaginationCustomer
            :listFlag="'warningTip'"
            v-if="waringDetail&&waringDetail.totalRow>10"
            :total="50||waringDetail.totalRow"
            @sizeChange="warningPageChange"
          ></PaginationCustomer>
        </el-tab-pane>
      </el-tabs>
    </div>
    <Dialog
      :visible="moreTipShow"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      @closeDialog="closeDialog('moreTipShow')"
    >
      <div class="signDetailDialog" slot="dialog">
        <div class="detailTipDscp" v-if="!sendTipSuccess">提醒频繁，请2小时后再来提醒！</div>
        <div class="detailTipDscp" v-if="sendTipSuccess">提醒发送成功！</div>
      </div>
    </Dialog>
    <!-- <Dialog
      :visible="contractStopShow"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      @closeDialog="closeDialog('contractStopShow')"
    >
      <div class="signDetailDialogWithButton" slot="dialog">
        <div class="authDscp">
          <p>是否要终止这份合同？</p>
        </div>
        <div class="authHandlerBox">
          <div class="button buttonActive cursorPointer">取消</div>
          <div class="button cursorPointer" @click="closeDialog('contractStopShow')">确定</div>
        </div>
      </div>
    </Dialog>-->
    <reject-sign
      v-if="rejectShow"
      @closeDialog="rejectShow=false"
      :taskId="rejectTaskId"
      @findPaw="findPawHandler"
      @restDetail="activeChange"
    ></reject-sign>
    <find-paw v-if="findPawShow" @closeDialog="findPawShow=false"></find-paw>
  </div>
</template>
<script>
import Breadcrumb from "../../../components/common/Breadcrumb.vue";
import HeaderDetail from "./components/signDetail/Header.vue";
import Slide from "./components/signDetail/Slide.vue";
import Dialog from "@common/Dialog.vue";
import FindPaw from "./components/signDetail/FindPaw.vue";
import RejectSign from "./components/signDetail/RejectSign.vue";
import PerformSign from "./../performance/components/performanceList/relyOn.vue";
import ChangeHistoryList from "./components/signDetail/ChangeHistoryList.vue";
import PaginationCustomer from "./components/signHome/PaginationCustomer.vue";
import WarningTipList from "./components/signDetail/WarningTipList.vue";
import BaseApi from "@lib/baseApi.js";
import annex from "./components/sign/annex.vue";
import {mapState} from "vuex";
export default {
  data() {
    return {
      hasPerform: false,
      activeName: "flow",
      moreTipShow: false,
      sendTipSuccess: false,
      contractCancelShow: false,
      contractStopShow: false,
      detail: null,
      historyList: [],
      waringList: [],
      waringDetail: [],
      rejectShow: false,
      findPawShow: false,
      rejectTaskId: false,
      WarningTipQuery: {
        pageSize: 10,
        pageNumber: 1
      },
      //附件的列表
      annexFileList: []
    };
  },
  computed:{
    ...mapState(['curState'])
  },
  components: {
    Breadcrumb,
    HeaderDetail,
    Slide,
    Dialog,
    FindPaw,
    RejectSign,
    PerformSign,
    ChangeHistoryList,
    PaginationCustomer,
    WarningTipList,
    annex
  },
  created() {
    this.activeChange("init");
  },
  mounted() {},
  methods: {
    rejectSignShow(taskId) {
      this.rejectTaskId = taskId;
      this.rejectShow = true;
    },
    downAll() {
      this.$refs.annex.downloadAll();
    },
    init() {
      var queryStr = {
        contractId: this.$route.query.id
      };
      BaseApi.createRpcToken("/perform/performTaskList", queryStr)
        .then(
          data => {
            if (
              data.datas &&
              data.datas.result &&
              data.datas.result.proforeTaskList &&
              data.datas.result.proforeTaskList.length
            ) {
              this.hasPerform = true;
              this.$nextTick(() => {
                this.$refs.performSign.setData(
                  data.datas.result.proforeTaskList
                );
              });
            } else {
              this.hasPerform = false;
            }
          },
          data => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    closeDialog(flag) {
      this[flag] = false;
    },
    findPawHandler() {
      this.rejectShow = false;
      this.findPawShow = true;
    },
    warningPageChange(query) {
      this.WarningTipQuery.pageSize = query.pageSize;
      this.WarningTipQuery.pageNumber = query.currentPage;
      this.activeChange();
    },
    goToFlow() {
      this.activeName = "flow";
      this.activeChange();
    },
    activeChange(flag) {
      if (this.activeName == "flow") {
        // 要刷新
        this.detail = null;
        BaseApi.createRpcToken("/contract/detail", {
          id: this.$route.query.id,
        })
          .then(
            data => {
              // console.log(data)
              this.detail = data.datas.detail;
              if (
                this.detail &&
                this.detail.info &&
                this.detail.info.signStatus == 2 &&
                flag == "init"
              ) {
                this.init();
              }
            },
            () => {}
          )
          .catch(function(e) {
            errorLog(e);
          });
      } else if (this.activeName == "waitSign") {
        this.init();
      } else if (this.activeName == "changeHistory") {
        BaseApi.createRpcToken("/contract/history", {
          id: this.$route.query.id
        })
          .then(
            data => {
              this.historyList = data.datas.list || [];
              console.log(this.historyList);
            },
            () => {}
          )
          .catch(function(e) {
            errorLog(e);
          });
      } else if (this.activeName == "waringSign") {
        this.WarningTipQuery.contractId = this.$route.query.id;
        BaseApi.createRpcToken("/warn/contractWarnList", this.WarningTipQuery)
          .then(
            data => {
              this.waringDetail = data.datas;
              this.waringList = data.datas.list || [];
            },
            () => {}
          )
          .catch(function(e) {
            errorLog(e);
          });
      }
    }
  },
   watch:{
    "curState"(data){
      this.$router.replace("/personal/sign/home")
    }
  }
};
</script>
<style lang="scss">
.sighDetailContainter {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  .annexContainer {
    overflow: hidden;
    margin-bottom: 15px;
    .annexDscp {
      margin-bottom: 20px;
      font-size: 12px;
      color: #787878;
      .annexTotal {
        color: #3c3c3c;
      }
      .annexTotalSize {
        color: #787878;
      }
      .delimit {
        font-size: 14px;
        margin-right: 10px;
        margin-left: 10px;
      }
      .allDoload {
        cursor: pointer;
        &:hover {
          color: #e88078;
        }
      }
    }
    img {
      margin-right: 5px;
    }
  }
  .signDetailDialog {
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    .detailTipDscp {
      font-size: 14px;
      color: #646464;
      text-align: center;
    }
  }
  .signDetailDialogWithButton {
    height: 200px;
    width: 400px;
    box-sizing: border-box;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 0 20px;
    .authDscp {
      font-size: 14px;
      color: #646464;
      letter-spacing: 0;
      text-align: center;
      line-height: 20px;
      padding-top: 20px;
    }
    .withInput {
      width: 100%;
      text-align: left;
      .el-input__inner {
        width: 100%;
        height: 32px;
        line-height: 32px;
      }
    }
  }
  .breadcrumbPosition {
    margin-bottom: 20px;
  }
  .listPosition {
    margin-bottom: 20px;
  }
  .signDetailTable {
    overflow-x: auto;
    .mainColor {
      color: #e88078;
    }
    .el-table {
      min-width: 1080px;
    }
    .cellCustomer {
      height: 32px;
      text-align: center;
      line-height: 32px;
      padding: 0;
      color: #969696;
      .reject {
        color: #969696;
        .icon {
          background: url(./../../../assets/images/personalSignHome/sign_icon_nor.png);
        }
        &:hover {
          .icon {
            background: url(./../../../assets/images/personalSignHome/sign_icon_hov.png);
          }
          color: #e88078;
        }
      }
      .reject {
        color: #969696;
        .icon {
          background: url(./../../../assets/images/personalSignHome/sign_icon_nor.png);
        }
        &:hover {
          .icon {
            background: url(./../../../assets/images/personalSignHome/sign_icon_hov.png);
          }
          color: #e88078;
        }
      }
      .continueSign {
        color: #969696;
        .icon {
          background: url(./../../../assets/images/personalSignHome/details_icon_nor.png);
        }
        &:hover {
          .icon {
            background: url(./../../../assets/images/personalSignHome/details_icon_hov.png);
          }
          color: #e88078;
        }
      }
      .tip {
        color: #969696;
        .icon {
          background: url(./../../../assets/images/personalSignHome/remind_icon_nor.png);
        }
        &:hover {
          .icon {
            background: url(./../../../assets/images/personalSignHome/remind_icon_hov.png);
          }
          color: #e88078;
        }
      }
      .delete {
        color: #969696;
        .icon {
          background: url(./../../../assets/images/personalSignHome/delete_icon_nor.png);
        }
        &:hover {
          .icon {
            background: url(./../../../assets/images/personalSignHome/delete_icon_hov.png);
          }
          color: #e88078;
        }
      }
      .download {
        color: #969696;
        .icon {
          background: url(./../../../assets/images/personalSignHome/down_icon_nor.png);
        }
        &:hover {
          .icon {
            background: url(./../../../assets/images/personalSignHome/down_icon_hov.png);
          }
          color: #e88078;
        }
      }
      .detail {
        color: #969696;
        .icon {
          background: url(./../../../assets/images/personalSignHome/details_icon_nor.png);
        }
        &:hover {
          .icon {
            background: url(./../../../assets/images/personalSignHome/details_icon_hov.png);
          }
          color: #e88078;
        }
      }
      .break {
        color: #969696;
        .icon {
          background: url(./../../../assets/images/personalSignHome/suspe_icon_nor.png);
        }
        &:hover {
          .icon {
            background: url(./../../../assets/images/personalSignHome/suspe_icon_hov.png);
          }
          color: #e88078;
        }
      }
      .icon {
        display: inline-block;
        height: 14px;
        width: 12px;
        vertical-align: middle;
        margin-right: 7px;
      }
      .twoLine {
        text-align: left;
      }
    }
    .headerCellCustomer {
      color: #505050;
      background-color: #f9f9f9;
    }
    .handlerBox {
      display: flex;
      justify-content: space-between;
    }
    .handlerBoxCenter {
      display: flex;
      justify-content: space-around;
    }
    .tableFooter {
      text-align: right;
      padding-right: 48px;
      color: #646464;
    }
  }
  .noHaveAnnex {
    height: calc(100% - 250px);
  }
  .tabContainer {
    .el-tabs {
      height: 100%;
    }
    .el-tabs__item {
      height: 33px;
      line-height: 30px;
      font-size: 12px;
      color: #646464;
      background: #f5f5f5;
      border-top: 3px solid #f5f5f5;
    }
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__item:hover {
      color: #e88078;
    }
    .el-tabs--card > .el-tabs__header {
      border-bottom: 1px solid #e4e8eb;
    }
    .el-tabs__item.is-active {
      color: #e88078;
      background-color: #ffffff;
      border-top: 3px solid #e88078;
    }
    .flowContainer {
      height: 100%;
      box-sizing: border-box;
      padding-top: 50px;
    }
    .performContainer {
      height: 100%;
      box-sizing: border-box;
      padding-bottom: 20px;
      padding-top: 10px;
      overflow-y: auto;
    }
    .el-tabs__content {
      box-sizing: border-box;
      border: 1px solid #e4e8eb;
      border-top: none;
      padding: 10px;
      height: calc(100% - 20px);
      overflow-y: auto;
      .el-tab-pane {
        height: 100%;
        .list {
          height: calc(100% - 40px);
          overflow-y: auto;
        }
      }
    }
  }
}
</style>
